
import Actions from '../actions';
import Button from '../../../../components/form/button.jsx';
import ControlGroup from '../../../../components/form/control-group.jsx';
import React from 'react';
import {Helmet} from 'react-helmet';
import {Link} from 'react-router-dom';
import Spinner from '../../../../components/form/spinner.jsx';
import Store from './store';
import TextControl from '../../../../components/form/text-control.jsx';
import { Recaptcha } from '../../../../components';
import { handleLocalStateChange } from '../../../../utils/react';


class ForgotPage extends React.Component {
  constructor(props) {

    super(props);

    this.input = {};
    this.state = Store.getState();
  }

  componentDidMount() {

    this.unsubscribeStore = Store.subscribe(this.onStoreChange.bind(this));

    if (this.input.email) {
      this.input.email.focus();
    }

    // per Ivan any pages like this that may be loaded directly should make any API call
    // to receive the first csrf token to store in a cookie to avoid any scenarios where first call returns a "forbidden" error
    // this user creds check will also automatically redirect to resume logged in session if there is one
    Actions.getUserCreds();
  }

  componentWillUnmount() {

    this.unsubscribeStore();

    Actions.resetStore();
  }

  onStoreChange() {

    this.setState(Store.getState());
  }

  handleSubmit(event) {

    event.preventDefault();
    event.stopPropagation();

    const { captcha } = this.state;

    Actions.forgot({
      email: this.input.email.value(),
      captcha,
    });

  }

  render() {

    const alerts = [];

    if (this.state.success) {
      alerts.push(
        <div key="success">
          <div className="alert alert-success">
            Check your inbox! If an account exists for that email address you should receive an email with a reset link.
          </div>
          <Link to="/login" className="btn btn-link">Back to login</Link>
        </div>
      );
    }

    if (this.state.validation.error) {
      alerts.push(
        <div key="danger" className="alert alert-danger">
          {this.state.validation.error}
        </div>
      );
    }

    let formElements;

    if (!this.state.success) {
      formElements = (
        <fieldset>
          <TextControl
            ref={(c) => (this.input.email = c)}
            name="email"
            label="What's your email?"
            autocomplete="email"
            hasError={this.state.validation.hasError.email}
            help={this.state.validation.help.email}
            disabled={this.state.loading}
            required={true}
            maxlength="256"
          />
          <ControlGroup
            hasError={this.state.validation.hasError.captcha}
            help={this.state.validation.help.captcha}
          >
            <Recaptcha
              onChange={handleLocalStateChange.bind(this, 'captcha')}
            />
          </ControlGroup>
          <ControlGroup hideLabel={true} hideHelp={true}>
            <Button
              type="submit"
              disabled={this.state.loading}
              inputClasses={{
                'btn-primary': true,
              }}
            >
              Send reset
              <Spinner space="left" show={this.state.loading} />
            </Button>
            <Link to="/login" className="btn btn-link">Back to login</Link>
          </ControlGroup>
        </fieldset>
      );
    }

    return (
      <section className="container">
        <Helmet>
          <title>Forgot password</title>
        </Helmet>
        <div className="container">
          <div className="forgot-header px-3 py-3 pt-md-5 pb-md-4 mx-auto text-center">
            <h1 className="display-4">Forgot your password?</h1>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <form className="auth-form" onSubmit={this.handleSubmit.bind(this)} method="post">
                {alerts}
                {formElements}
              </form>
            </div>
          </div>
        </div>
      </section>
    );
  }
}


export default ForgotPage;



// WEBPACK FOOTER //
// ./client/pages/main/login/forgot/index.jsx